export default {
  // 搜索区域
  searchPlaceholder: '请输入设备SN',
  labelSearchPlaceholder: '请输入标签',
  searchButton: '查询',
  addDeviceAlgorithm: '新增设备算法',

  // 表格列
  deviceSN: '设备SN',
  pullUrl: '拉流地址',
  pushUrl: '推流地址',
  label: '标签',
  yoloModel: 'YOLO模型',
  confThreshold: '置信度阈值',
  resolution: '分辨率',
  createTime: '创建时间',
  createdBy: '创建人',
  operation: '操作',

  // 弹窗标题
  addTitle: '新增设备算法',
  editTitle: '修改设备算法',

  // 表单字段
  deviceSNField: '设备SN',
  deviceSNPlaceholder: '请输入设备SN',
  pullUrlField: '拉流地址',
  pullUrlPlaceholder: '请输入拉流地址',
  pushUrlField: '推流地址',
  pushUrlPlaceholder: '请输入推流地址',
  sceneField: '场景',
  scenePlaceholder: '请选择场景',
  yoloModelField: 'YOLO模型',
  yoloModelPlaceholder: '选择场景后自动填充模型路径',
  confThresholdField: '置信度阈值',
  confThresholdPlaceholder: '0~1',
  resolutionField: '分辨率',
  resolutionPlaceholder: '请输入分辨率',
  addressField: '巡检地址',
  addressPlaceholder: '请输入地址',
  templateField: '巡检模板',
  templatePlaceholder: '请输入数组，例如：[{"label":"铆钉检测","require":"未发现铆钉","suggestion_no":"未发现铆钉，符合要求。","suggestion_has":"已发现铆钉，请及时清理。"}]',

  // 按钮
  edit: '修改',
  delete: '删除',
  cancel: '取消',
  confirm: '确定',

  // 校验提示
  deviceSNRequired: '请输入设备SN',
  pullUrlRequired: '请输入拉流地址',
  pushUrlRequired: '请输入推流地址',
  sceneRequired: '请选择场景',
  yoloModelRequired: '请选择场景以自动填充YOLO模型',
  confThresholdRequired: '请输入置信度阈值',
  confThresholdInvalid: '请输入0~1之间的数值',
  resolutionRequired: '请输入分辨率',
  resolutionInvalid: '请输入有效的数值',

  // 提示消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',

  // 删除确认
  deleteConfirmTitle: '确认删除',
  deleteConfirmContent: '是否删除设备 {sn} 的算法配置？',
  deleteConfirm: '删除',
}
